  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  } from 'vue-property-decorator';   
    

    @Options({
        name: "AulaPdf",
        components: {  CardRh  },   
    }) 
    export default class AulaPdf extends Vue { 
         
        @Prop( ) readonly service!: any  
        @Prop( ) readonly token!: any  
        
        public identificador = 1 ;   
        public url: any = "";
        public modal: any = "modal_pdf_perfil";
        public height_w: any =  window.innerHeight;
        public height_s: any =  screen.height;
 
        public gerarBoletim(){
            this.url =   null;  
            setTimeout(() => {
                this.url = this.service.getApiUrl() + '/Relatorio/Pdf?token=' + this.token ;
                this.identificador++;
            }, 2 ); 
        }
    } 
